import { Injectable } from '@angular/core';
import { TokenStore } from './token-store';

@Injectable()
export class InMemoryTokenStore extends TokenStore {
  private token: string | null = null;

  getToken(): string | null {
    return this.token;
  }

  setToken(token: string): void {
    this.token = token;
  }

  clearToken(): void {
    this.token = null;
  }
}
